















import {Component, Prop, Vue} from 'vue-property-decorator';
import {SelectableStore} from '@/components/mass-import/SelectableStore';
import {
  LINE_LIMIT_SITE_SELECTION_LEVEL_1,
  LINE_LIMIT_SITE_SELECTION_LEVEL_2,
  SITE_SELECT_LIMIT_LEVEL_1
} from '@/components/mass-import/MassImportConfig';

@Component({})
export default class StoreSelectionSummary extends Vue {

  @Prop({default: []}) readonly selectableStores: SelectableStore[];
  @Prop({default: {value: false}}) readonly allStoresSelectedContainer: {value: boolean};

  get selectedStores() {
    return this.selectableStores.filter(store => store.checked);
  }
  get lineCountLimit() {
    return this.selectableStores.filter(selectableStore => this.allStoresSelectedContainer.value || selectableStore.checked).length > SITE_SELECT_LIMIT_LEVEL_1
        ? LINE_LIMIT_SITE_SELECTION_LEVEL_2
        : LINE_LIMIT_SITE_SELECTION_LEVEL_1;
  }
}
